import React from 'react';
import Localize from 'react-intl-universal';

import { Field, useFormikContext } from 'formik';

import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

const GeneralInformationTab = ({ titles, genders, languages }) => {
  const { values } = useFormikContext();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            name='firstName'
            label={Localize.get('Booking.firstName') + ' *'}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            name='lastName'
            label={Localize.get('Booking.lastName') + ' *'}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>

        {values.isBookingPerson && (
          <Grid item xs={12} sm={6}>
            <Field
              name='vatNumber'
              label={Localize.get('Booking.vatNo')}
              as={TextField}
              fullWidth
              disabled
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <Field
            name='title'
            label={Localize.get('Booking.title')}
            as={TextField}
            select
            fullWidth
            disabled
          >
            {titles.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </Field>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            name='gender'
            label={Localize.get('Booking.gender')}
            as={TextField}
            select
            fullWidth
            disabled
          >
            {genders.map((g) => (
              <MenuItem key={g} value={g}>
                {g}
              </MenuItem>
            ))}
          </Field>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            name='language'
            label={Localize.get('Booking.language')}
            as={TextField}
            select
            fullWidth
            disabled
          >
            {languages.map((lang) => (
              <MenuItem key={lang} value={lang}>
                {lang}
              </MenuItem>
            ))}
          </Field>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            name='companyName'
            label={Localize.get('SignIn.companyName')}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Field
            name='customerReference'
            label={Localize.get('Booking.customerReference')}
            as={TextField}
            fullWidth
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
};

export default GeneralInformationTab;
